import * as yup from 'yup';
import { SelectServiceDatePageFormData } from './SelectServiceDatePageFormData';

export const SelectServiceDatePageFormSchema: yup.SchemaOf<SelectServiceDatePageFormData> = yup.object({
  selectedServiceDate: yup.date().label('Service date').required(),
});
